import { Box } from "@mui/material";
import React from "react";
import {
  GroupDetailsContainer,
  GroupOverviewBox,
  StyledBox,
  StyledDivider,
  StyledTypography,
  StyledTypographyDay,
  StyledTypographyMember,
} from "./style";
import CustomChip from "../common/chip/chip";
import theme from "../../theme";
import { ShipmentIconBox, StyledTypographyID } from "../ticket/style";

export const ListGroups = ({
  icon1,
  icon2,
  day,
  value,
  chiptitle,
  title,
  text,
  isActive,
}) => {
  return (
    <StyledBox isactive={isActive}>
      <GroupDetailsContainer>
        <GroupOverviewBox>
          <img src={icon1} alt="groupIcon" loading="lazy" />
          <Box>
            <StyledTypography>{title}</StyledTypography>
            <StyledTypographyMember>{text}</StyledTypographyMember>
          </Box>
        </GroupOverviewBox>
        <CustomChip
          title={chiptitle}
          color={theme.palette.custom.orderCards}
          background={theme.palette.custom.chipsBgColor}
        />
      </GroupDetailsContainer>
      <StyledDivider />
      <GroupDetailsContainer>
        <GroupOverviewBox>
          <ShipmentIconBox>
            <img loading="lazy" src={icon2} alt="weightIcon" />
          </ShipmentIconBox>
          <StyledTypographyID>{value}</StyledTypographyID>
          {/* <CustomChip
            title={chiptitle}
            color={theme.palette.custom.danger}
            background={theme.palette.custom.errorBg}
          /> */}
        </GroupOverviewBox>
        <StyledTypographyDay>{day}</StyledTypographyDay>
      </GroupDetailsContainer>
    </StyledBox>
  );
};
